<template>
  <div class="body">
    <div class="body_center">
      <div class="body_center_left">
        <div class="body_center_left_album">
          <div class="body_center_left_album_x">
            <div class="body_center_left_album_item" v-bind:class="{on_click:album_id=='-1'}" @click="albumFun('-1')">
              <div class="body_center_left_album_item_img"><img src="@/assets/imgs/find_home.png" /></div>
              <div class="body_center_left_album_item_title">首页</div>
            </div>
            <div class="body_center_left_album_item" v-bind:class="{on_click:album_id==item.tagId}" v-for="(item,index) in albumList" :key="index+1" @click="albumFun(item.tagId)">
              <div class="body_center_left_album_item_img"><img :src="item.icon" /></div>
              <div class="body_center_left_album_item_title">{{item.name}}</div>
            </div>
          </div>
        </div>
        <div class="body_center_left_top">
          <div class="body_center_left_top_list" v-if="album_id=='-1'">
            <div class="body_center_left_top_item" v-bind:class="{on_click:top_id=='1'}" @click="topListFun(1)">最新</div>
            <div class="body_center_left_top_item" v-bind:class="{on_click:top_id=='2'}" @click="topListFun(2)">人気</div>
            <div class="body_center_left_top_item" v-bind:class="{on_click:top_id=='3'}" @click="topListFun(3)">精選</div>
            <div class="body_center_left_top_item" v-bind:class="{on_click:top_id=='4'}" @click="topListFun(4)">フォロワー</div>
          </div>
          <!-- <div class="body_center_left_top_input">
            <input />
            <img src="@/assets/imgs/search_article.png" />
          </div> -->
        </div>
        <div class="body_center_left_content" v-if="album_id=='-1'||sonState">
          <div v-for="(item,index) in postList">
            <post-item :post.sync="item"></post-item>
          </div>
        </div>
        <div class="body_center_left_content_topic" v-else>
          <post-topic-item v-for="(item,index) in postTopicList" :postTopic="item" :index="index+1" @updatePostTopicId="postTopicFun"></post-topic-item>
        </div>
      </div>
      <div class="body_center_right">
        <recommended-users></recommended-users>
        <recruit></recruit>
        <download></download>
        <disclaimers></disclaimers>
      </div>
    </div>
  </div>
</template>

<script>
import recommendedUsers from '@/components/Right/recommendedUsers'
import Recruit from '@/components/Right/recruit'
import Download from '@/components/Right/download'
import Disclaimers from '@/components/Right/disclaimers'
import postItem from '@/components/find/postItem/index'
import postTopicItem from '@/components/find/postTopicItem/index'
import * as json from '@/assets/js/json'
  export default {
    components: {
      recommendedUsers,
      Recruit,
      Download,
      Disclaimers,
      postItem,
      postTopicItem,
    },
    data () {
      return {
        album_id: -1,
        top_id: 1,
        postTopicId: 0,
        size: 10,
        page: 1,
        postTopicList: [],
        albumList : [],
        postList: [],
        nextPageState: true,
        sonState: false
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy(){
      window.removeEventListener('scroll', this.handleScroll)
    },
    created () {
      this.fetch()
      this.getNewestList()
    },
    methods: {
      fetch(){
        let option ={
          current : this.page
        }
        json.post('/api/member/index/group_fetch', option).then((res) =>{
          let mergedArray= null
          this.albumList = res.data.data.navigations
          this.postList = res.data.data.newestPosts
        })
      },
      getNewestList(){
        let option ={
          size: this.size,
          current : this.page
        }
        let url = null
        if(this.top_id == 1){
          url = '/api/member/post/newest/list'
        }else if(this.top_id == 2){
          url = '/api/member/post/hot/list'
        }else if(this.top_id == 3){
          url = '/api/member/post/recommend/list'
        }else if(this.top_id == 4){
          url = '/api/member/post/follow/list'
        }
        json.post(url, option).then((res) =>{
          this.nextPageState = true
          let mergedArray= null
          if(this.page == 1){
            mergedArray = res.data.data.page.records
          }else{
            mergedArray = this.postList.concat(res.data.data.page.records)
          }
          this.postList = mergedArray
        })
      },
      collectFun(id,state){
        let option ={
          postId: id,
        }
        if(state){
          json.post('/api/member/post/favorite/delete', option).then((res) =>{
            this.fetch()
          })
        }else{
          json.post('/api/member/post/favorite/add', option).then((res) =>{
            this.fetch()
          })
        }
      },
      albumFun(id){
        this.page = 1
        this.album_id = id
        if(this.album_id != '-1'){
          this.sonState = false
          this.postTopicList = []
          this.getPostTopicList()
        }else{
          this.sonState = false
          this.fetch()
        }
      },
      getPostTopicList(){
        let option ={
          postTopicTagId : this.album_id,

        }
        json.post('/api/member/post_topic/tag/list', option).then((res) =>{
          this.postTopicList = res.data.data.postTopics
        })
      },
      getTopPostList(){
        let option ={
          size: this.size,
          current: this.page,
          postTopicId: this.postTopicId,
        }
        json.post('/api/member/post/topic/post/newest/list', option).then((res) =>{
          this.nextPageState = true
          this.postList = res.data.data.posts
          this.sonState = true
        })
      },
      postTopicFun(id){
        this.postTopicId = id
        this.getTopPostList()
      },
      topListFun(id){
        this.top_id = id
        this.page = 1
        this.postList = null
        this.getNewestList()
      },
      loginResFun(){
        this.$emit("loginResFun")
      },
      handleScroll() {
        const scrollTop = document.documentElement.scrollTop||document.body.scrollTop
        const windowHeight = document.documentElement.clientHeight || document.body.clientHeight
        const scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight
        if (scrollTop + windowHeight >= scrollHeight-5) {
          if(this.nextPageState){
            this.nextPageState = false
            if(this.album_id == '-1'){
              this.page ++
              if(this.sonState){
                this.getTopPostList()
              }else{
                this.getNewestList()
              }
            }else{
              
            }
          }
        }
      }
    }
  }
</script>
<style src="@/pages/index/find/index.css" scoped>

</style>
